import {combineReducers} from 'redux';
import userReducer from '../reducers/user';
import registerAttendaceReducer from './../reducers/registerAttendance';
import subordinatesReducer from './subordinate';
import menuReducer from './menu';



const rootReducer = (state, action) => {
    if (action.type === 'USER_LOGOUT') {
      state = undefined;
    }
    // if (action.type === 'LOADING') {
    //   state = {
    //     ...state,
    //     loading:action.loading
    //   };
    // }
  
    return appReducer(state, action);
};
const appReducer = combineReducers({
    user:userReducer,
    registerAttendace:registerAttendaceReducer,
    subordinate:subordinatesReducer,
    menu:menuReducer,
});


export default rootReducer;
